import { TERMS_OF_USE, REFUND_POLICY, PRIVACY_POLICY } from 'constants/politics';

interface ILink {
    title: string;
    link: string;
}

export const LINKS: ILink[] = [
    {
        title: 'basics.privacyPolicy',
        link: PRIVACY_POLICY,
    },
    {
        title: 'basics.termsOfUse',
        link: TERMS_OF_USE,
    },
    {
        title: 'basics.refundPolicy',
        link: REFUND_POLICY,
    },
];
